// IMPORTANT: Nav menu must not use jQuery to comply with the Stawywell dynamic
// header/footer
import {VK_TAB, VK_ESC} from './lib/keycodes';

function toggleBoolAttr(el, attrName) {
    const currentVal = el.getAttribute(attrName);
    if (currentVal === 'true') {
        el.setAttribute(attrName, 'false');
    } else {
        el.setAttribute(attrName, 'true');
    }
}

function closeSearch() {
    let searchContainer = document.querySelector('.nav-search-container');
    let searchToggle = document.querySelector('.open-search');
    let modalOverlay = document.querySelector('.modal-overlay.menu');

    // Check if these exist because these may not be there for the Kyruus nav.
    if (searchContainer) {
        searchContainer.classList.remove('view');
    }

    if (searchToggle) {
        searchToggle.innerHTML = '<i class="ss-community">search</i>';
    }

    if (modalOverlay) {
        modalOverlay.style.display = 'none';
        modalOverlay.style['z-index'] = '10';
    }
}

function slideDown(elem) {
    elem.style.display = 'block';
}

function slideUp(elem) {
    elem.style.display = 'none';
}

function slideToggle(elem) {
    if (elem.style.display === 'block') {
        slideUp(elem);
    } else {
        slideDown(elem);
    }
}

function indexInNodeList(node, nodeList) {
    var children = nodeList;
    var num = 0;
    for (var i=0; i<children.length; i++) {
         if (children[i]==node) return num;
         if (children[i].nodeType==1) num++;
    }
    return -1;
}

(function() {
    // ////////////////////////////////////// START MENU

    const mobileBtns = document.querySelectorAll('.mobile-btns');
    const navItemLinks = document.querySelectorAll('.nav-toggle');
    const backBtn = document.querySelector('.nav-item-back');
    const body = document.querySelector('body');

    // Don't allow scrolling on mobile menu when open
    window.addEventListener("resize", function(){
        if (this.width > 740) {
            body.classList.remove('noscroll');
        } else {
            if (mobileBtns[0].getAttribute('aria-expanded') === 'true') {
                body.classList.add('noscroll');
            }
        }
    });

    window.addEventListener('resize', function() {
        const modal = document.querySelector('.mobile-btns.open');
        const navBack = document.querySelector('.nav-item-back');
        const body = document.querySelector('body');
        if (window.innerWidth > 1224) {
          modal.setAttribute('aria-expanded', false);
          navBack.style.display = 'none';
          body.classList.remove('noscroll');
          body.classList.remove('modal-body');
        }
    })

    // Close the nav when clicking outside of the nav
    document.addEventListener('click', function(e) {
        const openNavItem = document.querySelector('.nav-item.open');
        const targetIsInsideNavItem = e.target.closest('.nav-item');
        if (openNavItem && !targetIsInsideNavItem) {
            slideUp(openNavItem.querySelector('.nav-dd'));
            openNavItem.classList.remove('open');
            for (let i = 0; i < navItemLinks.length; i++) {
                const navItemLink = navItemLinks[i];
                navItemLink.setAttribute('aria-expanded', 'false');
            }
            backBtn.style.display = 'none';
        }
    });

    // Mobile open/close
    for (let i = 0; i < mobileBtns.length; i++) {
        const mobileBtn = mobileBtns[i];
        mobileBtn.addEventListener('click', function(e) {
            e.preventDefault();
            for (let j = 0; j < mobileBtns.length; j++) {
                const item = mobileBtns[j];
                toggleBoolAttr(item, 'aria-expanded');
            }
            if (mobileBtn.getAttribute('aria-expanded') === 'true') {
                body.classList.add('noscroll');
            } else {
                body.classList.remove('noscroll');
            }
        });
    }

    // Add aria-expanded property to all nav-item-links on page load. We don't
    // add this with HTML because we have to support a CSS only menu for the
    // Kyruus Find a Doctor tool, and we don't want those users to see
    // aria-expanded when it won't work.
    for (let i = 0; i < navItemLinks.length; i++) {
        const item = navItemLinks[i];
        item.setAttribute('aria-expanded', 'false');
    }
    for (let i = 0; i < mobileBtns.length; i++) {
        const item = mobileBtns[i];
        item.setAttribute('aria-expanded', 'false');
    }

    // Nav Dropdown
    for (let i = 0; i < navItemLinks.length; i++) {
        const navItemLink = navItemLinks[i];
        navItemLink.addEventListener('click', function(e) {
            e.preventDefault();
            const keyboard =
                e.which === 0 ||
                e.detail === 0 ||
                e.mozInputSource === 6;

            const anchor = this;
            const navItem = anchor.closest('.nav-item');
            const navDropdown = navItem.querySelector('.nav-dd');
            let openItem = document.querySelector('.nav-item.open');

            if (openItem === navItem) {
                openItem = null;
            }

            const openMenuItem = function () {
                navItem.classList.toggle('open');
                slideToggle(navDropdown);
                // slideDown(navDropdown);
                toggleBoolAttr(anchor, 'aria-expanded');
                closeSearch();

                if (keyboard) {
                    navDropdown.querySelector('a').focus();
                }

                // This is important for mobile. Focusing on the anchor scrolls
                // past the header, but we want that to stay visible.
                navDropdown.scrollTop = 0;
            };

            if (window.innerWidth <= 1224) {
                backBtn.classList.add('open');
                backBtn.style.display = 'block';
            }

            if (openItem) {
                // Close anything that was open
                slideUp(openItem.querySelector('.nav-dd'));
                openItem.classList.remove('open');
                toggleBoolAttr(openItem.querySelector('.nav-item-link'), 'aria-expanded');

            }

            // Open the current item
            openMenuItem();
        });
    }

    backBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const openNavItem = document.querySelector('.nav-item.open');
        backBtn.classList.remove('open');
        backBtn.style.display = 'none';
        slideUp(openNavItem.querySelector('.nav-dd'));
        toggleBoolAttr(openNavItem.querySelector('.nav-item-link'), 'aria-expanded');
        openNavItem.classList.remove('open');
    });

    // ////////////////////////////////////// END MENU

    // ////////////////////////////////////// START ACCESSIBLE NAVIGATION

    const navAnchors = document.querySelectorAll('.nav-dd a');
    for (let i = 0; i < navAnchors.length; i++) {
        const item = navAnchors[i];
        item.addEventListener('keydown', e => {
            const anchor = e.target;
            const parentAnchor = anchor.closest('.nav-item').querySelector('.nav-item-link');
            const anchorContainer = anchor.closest('.nav-dd');
            const allAnchors = anchorContainer.querySelectorAll('a');
            const index = indexInNodeList(e.target, allAnchors);
            let nextFocus;

            switch (e.keyCode) {
                case VK_ESC:
                    // Close menu when focus is on a submenu link.
                    parentAnchor.click();
                    parentAnchor.focus();
                    break;
                case VK_TAB:
                    if (!e.shiftKey) {
                        // This is for a normal tab moving forward.
                        if (index + 1 < allAnchors.length) {
                            nextFocus = allAnchors[index + 1];
                        } else if (allAnchors.length) {
                            nextFocus = allAnchors[0];
                        }
                    } else {
                        // This is for a shift tab moving backward.
                        if (index - 1 >= 0) {
                            nextFocus = allAnchors[index - 1];
                        } else if (allAnchors.length) {
                            nextFocus = allAnchors[allAnchors.length - 1];
                        }
                    }
                    nextFocus.focus();
                    e.preventDefault();
                    break;
            }
        })
    }

    // ////////////////////////////////////// END ACCESSIBLE NAVIGATION
})();
